package one.healthium.data.user.mapper

import dev.gitlive.firebase.firestore.Timestamp
import one.healthium.data.user.dto.FoodItemDto
import one.healthium.data.user.storage.toTimestamp
import one.healthium.data.user.utils.toInstant
import one.healthium.domain.common.FoodUnit
import one.healthium.domain.user.models.FoodItemModel
import one.healthium.domain.user.models.FoodOptions

internal class FoodLogMapper {
    fun optionsToDto(id: String, options: FoodOptions): FoodItemDto {
        return FoodItemDto(
            _id = id,
            amount = options.amount,
            name = options.name,
            date = Timestamp.now(),
            calories = options.calories,
            fat = options.fat,
            carbohydrates = options.carbohydrates,
            fiber = options.fiber,
            protein = options.protein,
            tablespoon = options.tablespoon,
            cups = options.cups,
            pieces = options.pieces,
            portion = options.portion,
            unit = foodUnitToString(options.unit),
        )
    }

    fun modelToDto(foodItem: FoodItemModel): FoodItemDto {
        return FoodItemDto(
            _id = foodItem.id,
            amount = foodItem.amount,
            isLiquid = foodItem.isLiquid,
            name = foodItem.name,
            date = foodItem.date.toTimestamp(),
            calories = foodItem.calories,
            fat = foodItem.fat,
            carbohydrates = foodItem.carbohydrates,
            fiber = foodItem.fiber,
            protein = foodItem.protein,
            tablespoon = foodItem.tablespoon,
            cups = foodItem.cups,
            pieces = foodItem.pieces,
            unit = foodItem.unit?.let { foodUnitToString(it) },
        )
    }

    fun dtoToModel(foodItem: FoodItemDto): FoodItemModel {
        return FoodItemModel(
            id = foodItem.id,
            date = foodItem.date.toInstant(),
            amount = foodItem.amount,
            isLiquid = foodItem.isLiquid ?: false,
            name = foodItem.name,
            calories = foodItem.calories,
            fat = foodItem.fat,
            carbohydrates = foodItem.carbohydrates,
            fiber = foodItem.fiber,
            protein = foodItem.protein,
            tablespoon = foodItem.tablespoon,
            cups = foodItem.cups,
            pieces = foodItem.pieces,
            portion = foodItem.portion,
            unit = foodItem.unit?.let { stringToFoodUnit(it) },
        )
    }

    private fun stringToFoodUnit(value: String): FoodUnit? {
        return when (value) {
            "cup" -> FoodUnit.Cup
            "fl-oz" -> FoodUnit.FlOz
            "g" -> FoodUnit.Gram
            "ml" -> FoodUnit.Ml
            "oz" -> FoodUnit.Oz
            "piece" -> FoodUnit.Piece
            "tbsp" -> FoodUnit.Tablespoon
            "tsp" -> FoodUnit.Teaspoon
            "portion" -> FoodUnit.Portion
            else -> null
        }
    }

    fun foodUnitToString(unit: FoodUnit): String {
        return when (unit) {
            FoodUnit.Cup -> "cup"
            FoodUnit.FlOz -> "fl-oz"
            FoodUnit.Gram -> "g"
            FoodUnit.Ml -> "ml"
            FoodUnit.Oz -> "oz"
            FoodUnit.Piece -> "piece"
            FoodUnit.Tablespoon -> "tbsp"
            FoodUnit.Teaspoon -> "tsp"
            FoodUnit.Portion -> "portion"
        }
    }
}